import axios from 'axios';
import { useQuery, useMutation, useInfiniteQuery } from '@tanstack/react-query';
import { RetryOnError, verifyToken } from 'utils/VerifyToken';
import { checkForAuthorization } from 'utils/index';

// api/pitch-reels.js
export const FetchPitchReels = ({
  investor_id,
  limit = 10,
  viewType = 'preference',
  enabled = true,
  selectedStartupId,
  setSelectedStartupId,
  setSearchParams
}) => {
  return useInfiniteQuery({
    queryKey: ['pitch-reels', investor_id, viewType, limit, selectedStartupId],
    queryFn: ({ pageParam = null }) => {
      // console.log('Fetching with viewType:', viewType);
      return axios({
        method: 'get',
        url: `${process.env.REACT_APP_BASE_URL}/pitch-reel`,
        params: {
          investor_id,
          cursor: pageParam,
          limit,
          viewType,
          selectedStartupId
        },
        headers: {
          Authorization: `Bearer ${checkForAuthorization()}`,
        },
      });
    },
    getNextPageParam: (lastPage) => {
      return lastPage?.data?.hasMore ? lastPage?.data?.nextCursor : undefined;
    },
    initialPageParam: null,
    enabled: !!investor_id && enabled,
    refetchOnWindowFocus: false,
    retry: (failureCount, error) => {
      // console.log({ failureCount, error });
      // console.log(error?.response?.data?.message === "Selected startup not in deal-flow", "message");
      // if(error?.response?.data?.message === "Selected startup not in deal-flow") {
      //   window.location.href = "/pitch-reels"
      // }
      return RetryOnError(failureCount, error);
    },
    onError: (err) => {
      // console.log(err, "err")
      return verifyToken(err);
    },
  });
};

// Handle Pitch Reel Action (Like/Dislike)
export const HandlePitchReelAction = () => {
  return useMutation({
    mutationFn: ({ startupId, action, investorId }) => {
      return axios({
        method: 'post',
        url: `${process.env.REACT_APP_BASE_URL}/pitch-reel/action`,
        headers: {
          Authorization: `Bearer ${checkForAuthorization()}`,
          'Content-type': 'application/json',
        },
        data: { startupId, action, investorId },
      });
    },
    retry: 0,
    onError: (err) => {
      return verifyToken(err);
    },
  });
};

// Fetch Pitch Reel Stats
export const FetchPitchReelStats = ({ investor_id, enabled = true }) => {
  return useQuery({
    queryKey: ['pitch-reel-stats', investor_id],
    queryFn: () => {
      return axios({
        method: 'get',
        url: `${process.env.REACT_APP_BASE_URL}/pitch-reel/stats`,
        headers: {
          Authorization: `Bearer ${checkForAuthorization()}`,
        },
      });
    },
    select: (data) => {
      return {
        totalViewed: data?.data?.totalViewed || 0,
        shortlisted: data?.data?.shortlisted || 0,
        rejected: data?.data?.rejected || 0,
        conversionRate: data?.data?.conversionRate || 0,
      };
    },
    enabled: !!investor_id && enabled,
    refetchOnWindowFocus: false,
    retry: (failureCount, error) => {
      return RetryOnError(failureCount, error);
    },
    onError: (err) => {
      return verifyToken(err);
    },
  });
};

